import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { ActionItem, BoxList } from '@factorialco/deprecated-design-system'
import find from 'lodash/find'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import DateRange from 'modules/timeoff/components/DateRange'
import {
  leaveEmployee,
  leaveIsHourly,
  leaveTotalDaysOrHours,
  leaveUnits,
} from 'modules/timeoff/lib/leaveEmployees'
import type LeaveModel from 'modules/timeoff/store/models/Leave'
import type MedicalLeaveUpdate from 'modules/timeoff/store/models/MedicalLeaveUpdate'

// TODO: this looks like a bug. This component already has a index.module.css file and it is not being used
import styles from '../index.module.scss'

interface Props {
  leave: LeaveModel
  updates: MedicalLeaveUpdate[]
}

const getYears = (leave: LeaveModel) => {
  const years = Object.keys(leaveUnits(leave) ?? {})
  if (years.length < 2) return years[0]
  const yearEnd = years[years.length - 1]?.slice(2)
  return `${years[0]}/${yearEnd}`
}

const getNumberOfUnits = (leave: LeaveModel) => {
  const total = leaveTotalDaysOrHours(leave)
  const copy = leaveIsHourly(leave)
    ? i18n.tp('time_off.hours_with_years', {
        count: total,
      })
    : i18n.tp('time_off.days_with_years', {
        count: total,
      })
  return `${copy} (${getYears(leave)})`
}

const Item = ({ leave, updates }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const title = i18n.t('settings.leave_types.defaults.medical_leave')
  const isLegacyMedical = leave.leaveType?.isMedicalLeave
  const isOpen = !find(updates, (update) => update.isAlta)

  const onClickEdit = () => {
    const employee = leaveEmployee(leave)
    const myRoute = navigation.timeOff.leavesEditLeaveId.fullPath({ leave_id: leave.attributes.id })
    const anotherRoute = navigation.employees.id.timeOff.leavesEditLeaveId.fullPath({
      id: employee.attributes.id,
      leave_id: leave.attributes.id,
    })

    navigate(employee === users.current.employee ? myRoute : anotherRoute)
  }

  const Medical = () => (
    <ActionItem onClick={() => onClickEdit()} showIcon={false}>
      <div className={styles.leave}>
        <DateRange leave={leave} disabled={isOpen} />
        <div className={styles.body}>
          <div className={styles.title} title={title}>
            {title}
          </div>
          <div className={styles.description} title={leave.attributes.description}>
            {getNumberOfUnits(leave)}
          </div>
        </div>
      </div>
    </ActionItem>
  )
  if (!isLegacyMedical) return <Medical />
  return (
    <BoxList>
      <Medical />
    </BoxList>
  )
}

export default observer(Item)
